const General = (global) => {
    return ({
        type: 'global',
        global
    })
}

const Process = (user) => {
    return ({
        type: 'inscripcion',
        user
    })
}

export {General, Process};